var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavTips = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wand",
    clipPath: "url(#clip0_0_66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.46643 0.15625L8.94214 1.30625L10.125 1.76875C10.2214 1.80625 10.2857 1.9 10.2857 2C10.2857 2.1 10.2214 2.19375 10.125 2.23125L8.94214 2.69375L8.46643 3.84375C8.42786 3.9375 8.33143 4 8.22857 4C8.12571 4 8.02929 3.9375 7.99072 3.84375L7.515 2.69375L6.33214 2.23125C6.23571 2.19375 6.17143 2.1 6.17143 2C6.17143 1.9 6.23571 1.80625 6.33214 1.76875L7.515 1.30625L7.99072 0.15625C8.02929 0.0625 8.12571 0 8.22857 0C8.33143 0 8.42786 0.0625 8.46643 0.15625ZM3.55821 2.30312L4.24929 3.86875L5.85964 4.54063C6.04929 4.61875 6.17143 4.8 6.17143 5C6.17143 5.2 6.04929 5.38125 5.85964 5.45937L4.24929 6.13125L3.55821 7.69687C3.47786 7.88125 3.29143 8 3.08571 8C2.88 8 2.69357 7.88125 2.61321 7.69687L1.92214 6.13125L0.311786 5.45937C0.122143 5.38125 0 5.2 0 5C0 4.8 0.122143 4.61875 0.311786 4.54063L1.92214 3.86875L2.61321 2.30312C2.69357 2.11875 2.88 2 3.08571 2C3.29143 2 3.47786 2.11875 3.55821 2.30312ZM14.9143 10.5C15.12 10.5 15.3064 10.6188 15.3868 10.8031L16.0779 12.3687L17.6882 13.0406C17.8779 13.1187 18 13.3 18 13.5C18 13.7 17.8779 13.8813 17.6882 13.9594L16.0779 14.6313L15.3868 16.1969C15.3064 16.3813 15.12 16.5 14.9143 16.5C14.7086 16.5 14.5221 16.3813 14.4418 16.1969L13.7507 14.6313L12.1404 13.9594C11.9507 13.8813 11.8286 13.7 11.8286 13.5C11.8286 13.3 11.9507 13.1187 12.1404 13.0406L13.7507 12.3687L14.4418 10.8031C14.5221 10.6188 14.7086 10.5 14.9143 10.5ZM14.7857 1C15.1393 1 15.48 1.1375 15.7339 1.38125L17.0936 2.70312C17.3443 2.95 17.4857 3.28125 17.4857 3.625C17.4857 3.96875 17.3443 4.3 17.0936 4.54688L14.2586 7.30313L11.0025 4.1375L13.8375 1.38125C14.0914 1.1375 14.4321 1 14.7857 1ZM1.42071 13.4531L9.91286 5.19688L13.1689 8.3625L4.67679 16.6187C4.42286 16.8625 4.08214 17 3.72857 17C3.375 17 3.03429 16.8625 2.78036 16.6187L1.42071 15.2969C1.17 15.05 1.02857 14.7188 1.02857 14.375C1.02857 14.0312 1.17 13.7 1.42071 13.4531Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavTips);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-tips.bc16acb53dc7ea5f4f088226bc93421b.svg";